import {
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  TokenRequest,
  UserResponse,
} from '../types'

import { pythonApi } from '../../../app/services/api/api'

const extendedApi = pythonApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['List'],
    }),
    getProfile: builder.query<UserResponse, void>({
      query: () => 'profile',
    }),
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: (email) => ({
        url: '/auth/forgotten-password',
        method: 'POST',
        body: email,
      }),
    }),
    resetPassword: builder.mutation<void, ResetPasswordRequest>({
      query: (data) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body: data,
      }),
    }),
    changePassword: builder.mutation<void, ResetPasswordRequest>({
      query: (data) => ({
        url: '/auth/change-password',
        method: 'POST',
        body: data,
      }),
    }),
    getAccountSettings: builder.query<{ full_name: string; email: string }, void>({
      query: () => '/auth/account-settings',
    }),
    updateAccountSettings: builder.mutation<void, { full_name: string; email: string }>({
      query: (data) => ({
        url: '/auth/account-settings',
        method: 'PUT',
        body: data,
      }),
    }),
    validateToken: builder.query<void, TokenRequest>({
      query: (token) => ({
        url: '/auth/validate-token',
        method: 'POST',
        body: token,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useLoginMutation,
  useLazyGetProfileQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useGetAccountSettingsQuery,
  useUpdateAccountSettingsMutation,
  useLazyValidateTokenQuery,
} = extendedApi
